import type React from "react";
import { strings } from "@/I18n";
import { ResponsiveModal } from "@/v2/ui/composed/responsive-modal";
import { Badge } from "@/v2/ui/primitives/badge";

export interface FilterModalBaseProps {
  open: boolean;
  onClose: () => void;
  onReset: () => void;
  onConfirm: () => void;
  hasActiveFilters: boolean;
  activeFilterCount: number;
  children: React.ReactNode;
  title?: string;
  maxWidth?: string;
  resetDisabled?: boolean;
}

export function FilterModalBase({
  open,
  onClose,
  onReset,
  onConfirm,
  hasActiveFilters,
  activeFilterCount,
  children,
  title,
  maxWidth = "tw-max-w-md",
  resetDisabled,
}: FilterModalBaseProps) {
  return (
    <ResponsiveModal
      open={open}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      title={
        <div className="tw-flex tw-items-center tw-gap-2">
          <span>{title || strings("title.filter")}</span>
          {hasActiveFilters && (
            <Badge
              variant="secondary"
              className="tw-text-[10px] tw-px-1.5 tw-py-0"
            >
              {activeFilterCount}
            </Badge>
          )}
        </div>
      }
      onReset={onReset}
      resetDisabled={resetDisabled ?? !hasActiveFilters}
      onConfirm={onConfirm}
      maxWidth={maxWidth}
    >
      <div className="tw-space-y-4 tw-py-2">{children}</div>
    </ResponsiveModal>
  );
}
